import { ApolloClient, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const uploadLink = createUploadLink({
  uri: API_URL,
});

const authLink = setContext(async (_, { headers }) => {
  // Get the Clerk session token
  let token = null;
  try {
    // Access Clerk's active session and get the token
    // This assumes Clerk is initialized and session is active.
    // Adjust if your Clerk instance is accessed differently.
    if (window.Clerk && window.Clerk.session) {
      token = await window.Clerk.session.getToken();
    }
  } catch (error) {
    console.error("Error getting Clerk token for Apollo Client:", error);
    // Handle error appropriately, maybe sign out user or show message
  }

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "", // Add the Authorization header
      'apollo-require-preflight': 'true', // Add this header for CSRF prevention with uploads
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache(),
  connectToDevTools: false,
});

export default client;
